import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import apiService from '../../../services/apiService';
import { Link } from 'react-router-dom';
import CustomToast from '../../Toast';
import Loader2 from '../../layouts/loader2';
import { useTranslation } from 'react-i18next';
import Lottie from "lottie-react";
import { useNavigate } from 'react-router-dom';

const CourseCompletedModal = ({ setIsComleted, course_id, course_name }) => {
    const navigate = useNavigate();

    const [courseCompletedModalIsOpen, setCourseCompletedModalIsOpen] = useState(false);
    const [loader, setLoader] = useState(false);
    const { t } = useTranslation();
    const { i18n } = useTranslation();
    const currentLang = localStorage.getItem('userLang')
    const [CelebrationData, setCelebrationData] = useState(null);

    const getLangCode = (lang) => {
        switch (lang) {
            case 'English':
                return 'en';
            case 'Hindi':
                return 'hi';
            case 'Marathi':
                return 'mar';
            default:
                return 'en';
        }
    };

    const langId = getLangCode(currentLang);
    const tForLang = i18n.getFixedT(langId);

    const closeCourseCompletedModal = () => {
        setIsComleted(false);
        navigate('/'); 
    };

    const getCertificate = async (courseDetails) => {
        setLoader(true);
        let user_details = sessionStorage.getItem('user_details')
        let data = {
            "course_id": course_id,
            // ||courseDetails?.course_id,
            "send_email": true,
            "user_id": JSON.parse(user_details)?.uid,
            course_name,
            course_lang: localStorage.getItem('selectedLanguage')
        }
        const token = apiService.getAuthToken()
        await apiService.postV1(`generate-certificate`, data, token).then((data) => {
            if (data?.status) {
                console.log("cdewcdwcewcew");
                window.open(data?.data?.certificate_url, "_blank")
                setLoader(false);
            }
        }).catch(error => {
            console.log("cdewcdwcewcew");
            CustomToast.error(error);
            setLoader(false);
        })
    }

    // const downloadCertificate = async () => {
    //     setLoader(true);
    //     const user_details = JSON.parse(sessionStorage.getItem('user_details'));
    //     const data = {
    //         course_id: course_id,
    //         send_email: false,
    //         user_id: user_details?.uid,
    //         course_name,
    //         course_lang: localStorage.getItem('selectedLanguage'),
    //     };
    //     const token = apiService.getAuthToken();

    //     try {
    //         const res = await apiService.postV1('generate-certificate', data, token);

    //         if (res?.status && res?.data?.certificate_url) {
    //             const link = document.createElement('a');
    //             link.href = res.data.certificate_url;
    //             link.download = `${course_name.replace(/\s+/g, '_')}_certificate.pdf`;
    //             link.target = '_blank';
    //             document.body.appendChild(link);
    //             link.click();
    //             document.body.removeChild(link);
    //         } else {
    //             CustomToast.error("Certificate not found.");
    //         }
    //     } catch (error) {
    //         console.error("Download failed:", error);
    //         CustomToast.error("Something went wrong while downloading.");
    //     } finally {
    //         setLoader(false);
    //     }
    // };


    useEffect(() => {
        const fetchLottie = async () => {
            try {
                const [CelebrationRes] = await Promise.all([
                    fetch("/images/celebration.json"),
                ]);

                const [celebration] = await Promise.all([
                    CelebrationRes.json(),

                ]);

                setCelebrationData(celebration);

            } catch (error) {
                console.error("Error loading Lottie files:", error);
            }
        };

        fetchLottie();
    }, []);

    return (
        <form>

            {loader ? <Loader2 /> : <>

                <div className="custom-overlay video-questions quiz px-3">
                    <div className='d-flex flex-column justify-content-center align-items-center text-center'>
                        <div className='card congrats-card position-relative mt-5' style={{ borderRadius: '25px' }}>
                        <button 
                                onClick={closeCourseCompletedModal}
                                className='position-absolute close-button'
                            >
                                <svg width="24" height="24" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="0.548828" width="27.4625" height="27.4517" rx="13.7259" fill="#146B90" />
                                    <path d="M19.619 17.6867C20.0081 18.0758 20.0081 18.6811 19.619 19.0702C19.4245 19.2647 19.1867 19.3512 18.9273 19.3512C18.6679 19.3512 18.4301 19.2647 18.2355 19.0702L14.2796 15.1143L10.3237 19.0702C10.1292 19.2647 9.89141 19.3512 9.63201 19.3512C9.3726 19.3512 9.13482 19.2647 8.94027 19.0702C8.55116 18.6811 8.55116 18.0758 8.94027 17.6867L12.8962 13.7308L8.94027 9.77492C8.55116 9.38582 8.55116 8.78054 8.94027 8.39144C9.32937 8.00233 9.93464 8.00233 10.3237 8.39144L14.2796 12.3473L18.2355 8.39144C18.6246 8.00233 19.2299 8.00233 19.619 8.39144C20.0081 8.78054 20.0081 9.38582 19.619 9.77492L15.6631 13.7308L19.619 17.6867Z" fill="white" />
                                </svg>
                            </button>
                            
                            <div className='d-flex flex-column justify-content-center align-items-center text-center'>
                               
                                <div className="congrats-image-container">

                                    <img src='/images/congrats.png' alt='congratulations' className="congrats-image w-100" />
                                    <h3 className='fw-bold font-26 my-4'>{tForLang('course_modules_congratulations')}</h3>
                                    <p className='text-center px-4'>{tForLang('course_modules_completed_course_successfully')}</p>
                                     <div className="d-flex justify-content-end align-items-center w-100 my-3 mb-0 btn-group-wrapper mt-lg-5 mt-4 pe-3 border-top pt-3"> 
                                        {/* <button
                                            type="button"
                                            className="btn btn-light border rounded-pill me-2"
                                            // onClick={downloadCertificate}
                                        >
                                            {tForLang('home_page_download_certificate')}
                                        </button> */}

                                        <button
                                            type="button"
                                            className="btn btn rounded-pill mb-4"
                                            style={{ backgroundColor: "#23a298", color: "#fff", border: "none" }}
                                            onClick={getCertificate}
                                        >
                                            {tForLang('course_modules_view_certificate')}
                                        </button>
                                       
                                        <div className="celebration-wrapper">
                                            {CelebrationData && (
                                                <Lottie
                                                    animationData={CelebrationData}
                                                    loop
                                                    autoplay
                                                    className="celebration-lottie"
                                                />
                                            )}
                                        </div>
                                    
                                    </div>
                                
                                </div>
                            </div>
                        </div></div></div>
            </>
            }
        </form>
    )
}

export default CourseCompletedModal;